import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/sun/node_modules/@vercel/analytics/dist/react/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/sun/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/sun/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/sun/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans_JP\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"notoJp\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/sun/src/app/components/Elements/FadeIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/sun/src/app/components/Layout/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/sun/src/app/globals.css");
